import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from "rxjs/Observable";
import { shareReplay } from 'rxjs/operators';
import {environment} from "../../environments/environment";
import {VehicleOwner, VehicleListEntity, MakeOrModel} from '../models/sysvehicles';
;


@Injectable({
  providedIn: 'root'
})
export class VehicleServices {

constructor(private http: HttpClient ) { }




public getAllOrSearchVehicles(searchString: string, page: number, pageSize: number){

    if(searchString != null &&  searchString.trim() != ""){
        return  this.searchVehicles(searchString,page ,pageSize);
    }
    else{
        return  this.getVehicles(page ,pageSize);
    }

}

public getVehicles(page: number, pageSize: number): Observable<VehicleOwner[]> {
    return this.http.get<VehicleOwner[]>(environment.APIENDPOINT + '/vehicles/list?page='+page+'&size='+pageSize, {
      headers: this.setHeaders(),
      responseType: 'json'
    });
  }

  public searchVehicles(searchString: string , page: number, pageSize: number): Observable<VehicleOwner[]> {
    return this.http.get<VehicleOwner[]>(environment.APIENDPOINT + '/vehicles/search?searchString='+searchString+'&page='+page+'&size='+pageSize, {
      headers: this.setHeaders(),
      responseType: 'json'
    });
  }

  public searchVehiclesByExactNumber(exactVehicleNumber: string, page: number, pageSize: number): Observable<VehicleOwner[]> {
    return this.http.get<VehicleOwner[]>(environment.APIENDPOINT + '/vehicles/search?exactVehicleNumber=' + encodeURIComponent(exactVehicleNumber) + '&page=' + page + '&size=' + pageSize, {
      headers: this.setHeaders(),
      responseType: 'json'
    });
  }


  private makesCache$: Observable<MakeOrModel[]> | null = null;

  getVehicleMakes(forceRefresh: boolean = false) : Observable<MakeOrModel[]> {
    if (!this.makesCache$ || forceRefresh) {
      this.makesCache$ = this.http.get<MakeOrModel[]>( environment.APIENDPOINT +  '/vehicles/makes',
      {
          headers: this.setHeaders(),
          responseType: 'json'
        }).pipe(shareReplay(1));
    }
    return this.makesCache$;
  }

    getVehicleModelsforMake(makeId: number) : Observable<MakeOrModel[]> {
    return this.http.get<MakeOrModel[]>( environment.APIENDPOINT +  '/vehicles/makes/'+makeId,{
        headers: this.setHeaders(),
        responseType: 'json'
      });
    }

    //make crud
    createVehicleMake(name: string): Observable<MakeOrModel> {
      return this.http.post<MakeOrModel>(
        environment.APIENDPOINT + '/vehicles/makes',
        { name },
        { headers: this.setHeaders(), responseType: 'json' }
      );
    }

    updateVehicleMake(makeId: number, name: string): Observable<MakeOrModel> {
      return this.http.put<MakeOrModel>(
        environment.APIENDPOINT + '/vehicles/makes/' + makeId,
        { name },
        { headers: this.setHeaders(), responseType: 'json' }
      );
    }

    deleteVehicleMake(makeId: number): Observable<any> {
      return this.http.delete(
        environment.APIENDPOINT + '/vehicles/makes/' + makeId,
        { headers: this.setHeaders() }
      );
    }

    // model crud
    createVehicleModel(makeId: number, name: string): Observable<MakeOrModel> {
      return this.http.post<MakeOrModel>(
        environment.APIENDPOINT + '/vehicles/makes/' + makeId + '/models',
        { name },
        { headers: this.setHeaders(), responseType: 'json' }
      );
    }

    updateVehicleModel(modelId: number, name: string): Observable<MakeOrModel> {
      return this.http.put<MakeOrModel>(
        environment.APIENDPOINT + '/vehicles/models/' + modelId,
        { name },
        { headers: this.setHeaders(), responseType: 'json' }
      );
    }

    deleteVehicleModel(modelId: number): Observable<any> {
      return this.http.delete(
        environment.APIENDPOINT + '/vehicles/models/' + modelId,
        { headers: this.setHeaders() }
      );
    }

    public editVehicle(vehicle: VehicleListEntity) {

        return this.http.post(environment.APIENDPOINT + "/vehicles", vehicle,
            {
                headers: this.setHeaders(),
                responseType: 'json'
            }
        );

    }

    public AddNewVehicleToCustomet(customerVihecles: VehicleOwner) {
        return this.http.post(environment.APIENDPOINT + "/customers", customerVihecles,
            {
                headers: this.setHeaders(),
                responseType: 'json'
            }
        );
    }





  private setHeaders() {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let userTenant = localStorage.getItem('userTenant');
    let authHeader = new HttpHeaders({'Authorization': 'Bearer ' + currentUser.token , 'X-Tenant' : userTenant });
    return authHeader;
  }



}


